import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/employees',
        name: 'EmployeesView',
        meta: {
            moduleId: 'employeesOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        component: () => import(/* webpackChunkName: "employees-view" */ '../../../replacements/modules/employees/components/EmployeesView'),
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/employees/:id',
        name: 'EmployeeForm',
        component: () => import(/* webpackChunkName: "employees-form" */ '../../../replacements/modules/employees/components/EmployeeForm'),
        meta: { 
            moduleId: 'employeesOverview',
            registries: ['configurations/employees'],
            registries: ['configurations/profile'],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/users',
        name: 'UserOverview',
        component: () => import(/* webpackChunkName: "users-view" */ '../../../replacements/modules/users/components/UserOverview'),
        meta: {
            moduleId: 'userOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/users/:id',
        name: 'UserForm',
        component: () => import(/* webpackChunkName: "users-form" */ '../../../replacements/modules/users/components/UserForm'),
        meta: { 
            moduleId: 'userOverview', 
            registries: ['configurations/profile'], 
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/departments',
        name: 'DepartmentsView',
        component: () => import(/* webpackChunkName: "departmens-view" */ '@/modules/organisation/departments/components/DepartmentsView'),
        meta: {
            moduleId: 'departmentOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter(to, from, next) {
            checkAuthenticated(to, from, next);
            to.params['showFilter'] = false;
        }
    },
    {
        path: '/departments/:id',
        name: 'DepartmentsForm',
        component: () => import(/* webpackChunkName: "departmens-form" */ '@/modules/organisation/departments/components/DepartmentsForm'),
        meta: { moduleId: 'departmentOverview'},
        props: true,
        beforeEnter(to, from, next) {
            beforeEnterCheck(to, from, next);
            to.params['deletable'] = false;
        }
    },
    {
        path: '/occupationgroups',
        name: 'OccupationGroupsView',
        component: () => import(/* webpackChunkName: "occupationgroups-view" */ '@/modules/organisation/occupation_groups/components/OccupationGroupsView'),
        meta: {
            moduleId: 'occupationGroupOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/occupationgroups/:id',
        name: 'OccupationGroupForm',
        component: () => import(/* webpackChunkName: "occupationgroups-form" */ '../../../replacements/modules/organisation/occupation_groups/components/OccupationGroupForm'),
        meta: { moduleId: 'occupationGroupOverview' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/roles',
        name: 'RolesView',
        component: () => import(/* webpackChunkName: "roles-view" */ '@/modules/roles/components/RolesView'),
        meta: {
            moduleId: 'roleOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/roles/:id',
        name: 'RoleForm',
        component: () => import(/* webpackChunkName: "roles-form" */ '@/modules/roles/components/RoleForm'),
        meta: { moduleId: 'roleOverview' },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/accessGroups',
        name: 'AccessGroupsView',
        component: () => import(/* webpackChunkName: "accessgroup-view" */ '@/modules/access_groups/components/AccessGroupsView'),
        meta: {
            moduleId: 'accessgroupOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/accessGroups/:id',
        name: 'AccessGroupForm',
        component: () => import(/* webpackChunkName: "accessgroup-form" */ '@/modules/access_groups/components/AccessGroupForm'),
        meta: { 
            moduleId: 'accessgroupOverview'
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/overtimetrims',
        name: 'OvertimeTrimView',
        component: () => import(/* webpackChunkName: "overtimetrim-view" */ '@/modules/overtime_trims/components/OvertimeTrimView'),
        meta: {
            moduleId: 'overtimeTrimOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/overtimetrims/:id',
        name: 'OvertimeTrimForm',
        component: () => import(/* webpackChunkName: "overtimetrim-form" */ '@/modules/overtime_trims/components/OvertimeTrimForm'),
        meta: { 
            moduleId: 'overtimeTrimOverview',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/companylocations',
        name: 'CompanyLocationsView',
        component: () => import(/* webpackChunkName: "companylocations-view" */ '@/modules/company_locations/components/CompanyLocationsView'),
        meta: {
            moduleId: 'companylocations',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
        },
        preloads: [
            'system/countries/default',
        ],
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/companylocations/:id',
        name: 'CompanyLocationsForm',
        component: () => import(/* webpackChunkName: "companylocations-form" */ '@/modules/company_locations/components/CompanyLocationsForm'),
        meta: {
            moduleId: 'companylocations',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/deputytypes',
        name: 'DeputyTypesView',
        component: () => import(/* webpackChunkName: "deputytypes-view" */ '@/modules/deputy_types/components/DeputyTypesView'),
        meta: {
            moduleId: 'deputytypes',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID]
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/deputytypes/:id',
        name: 'DeputyTypeForm',
        component: () => import(/* webpackChunkName: "deputytypes-form" */ '@/modules/deputy_types/components/DeputyTypeForm'),
        meta: {
            moduleId: 'deputytypes',
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
];
